/* HO-CUSTOM rewrite of the vendor component-quantity.js (v3 - delegated).
   History:
   - Vendor version guarded all binding behind a phantom #quantity element that no template
     renders, so the product-page +/- buttons were never bound at all.
   - v1/v2 bound listeners per-element at load, but variant changes (e.g. products with a
     "Quantity" option like Nutrifield Coco Perlite) re-render the buy box and destroy the
     bound elements, after which the hidden name="quantity" fields in the add form go stale
     at "1" again. Shopify honours the LAST quantity value in the submitted form data, so
     adds landed as quantity 1 regardless of the visible input.
   v3 uses document-level EVENT DELEGATION (survives any re-render) plus a capture-phase
   submit listener that force-syncs every quantity field in the product form from the form's
   own visible input at the moment of submission. Cart line items (.cart-item) are excluded -
   their +/- buttons are managed by the cart service in base.js. Quick-add forms are excluded
   automatically (they carry no visible quantity field). */
!(function () {
  "use strict";
  // Featured sections may include this asset again; delegation needs one binding.
  if (window.__hoProductQuantityBound) return;
  window.__hoProductQuantityBound = true;
  var SCOPES = '.main-product__content, .sticky-add-to-cart';

  function inCartItem(el) {
    return !!(el && el.closest && el.closest('.cart-item'));
  }
  function productScope(el) {
    return el && el.closest ? el.closest(SCOPES) : null;
  }

  /* Every quantity field that could reach a /cart/add submission from the product page:
     visible + hidden fields inside the buy box and sticky bar, plus everything associated
     with the main product form (covers form="..." associated elements). Collected fresh on
     every use so re-rendered elements are always included. */
  function allQuantityFields() {
    var out = [];
    function collect(el) {
      if (el && out.indexOf(el) === -1) out.push(el);
    }
    document.querySelectorAll(SCOPES).forEach(function (scope) {
      scope.querySelectorAll('input[name="quantity"]').forEach(collect);
    });
    document.querySelectorAll('form[id^="form-product-"]').forEach(function (form) {
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.name === 'quantity') collect(el);
      });
    });
    return out;
  }

  function syncAll(v, except) {
    allQuantityFields().forEach(function (el) {
      if (el !== except) el.value = v;
    });
  }

  /* Plus / minus clicks in the buy box or sticky bar (NOT cart line items). */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="plus"], button[name="minus"]') : null;
    if (!btn || inCartItem(btn)) return;
    var scope = productScope(btn);
    if (!scope) return;
    var input = scope.querySelector('.quantity input[name="quantity"]') || scope.querySelector('input[name="quantity"]:not([type="hidden"])');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    v = btn.getAttribute('name') === 'plus' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    syncAll(v, input);
  });

  /* Keystroke-level sync so typed values reach the hidden fields immediately. */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || el.name !== 'quantity' || inCartItem(el) || !productScope(el)) return;
    var v = parseInt(el.value, 10);
    if (!isNaN(v) && v >= 1) syncAll(v, el);
  });

  /* Normalise on change (empty / invalid -> 1). */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.name !== 'quantity' || inCartItem(el) || !productScope(el)) return;
    var v = parseInt(el.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    el.value = v;
    syncAll(v, el);
  });

  /* Digits only. */
  document.addEventListener('keypress', function (e) {
    var el = e.target;
    if (!el || el.name !== 'quantity' || inCartItem(el) || !productScope(el)) return;
    if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) e.preventDefault();
  });

  /* Submit-time guarantee: capture phase runs BEFORE the theme's own submit handler builds
     its FormData. The authoritative value is the form's own last VISIBLE quantity field;
     forms with no visible quantity field (e.g. collection quick-add) are left untouched. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.elements) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    var fields = Array.prototype.filter.call(form.elements, function (el) {
      return el.name === 'quantity';
    });
    if (!fields.length) return;
    var visible = fields.filter(function (el) {
      return el.type !== 'hidden' && el.getClientRects().length;
    });
    if (!visible.length) return; // quick-add etc: nothing visible to trust
    var v = parseInt(visible[visible.length - 1].value, 10);
    if (isNaN(v) || v < 1) v = 1;
    fields.forEach(function (el) { el.value = v; });
  }, true);
})();
